import { render, staticRenderFns } from "./add-card.vue?vue&type=template&id=3a8d3a13&scoped=true&"
import script from "./add-card.vue?vue&type=script&lang=js&"
export * from "./add-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d3a13",
  null
  
)

export default component.exports